import { ROUTES } from '@/constants/app';
import { useMarque } from '@/hooks/useMarque';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface FooterProps {
  variant?: 'auth' | 'app';
}

export const Footer: React.FC<FooterProps> = ({ variant = 'auth' }) => {
  const { t } = useTranslation();
  // [C2 — marque blanche] Le nom au copyright est celui de la marque servie.
  // « © Innov' Paie » en bas d'une plateforme qui porte le nom d'un cabinet est
  // la dernière ligne qui trahit la marque blanche — et c'est celle que tout
  // le monde oublie.
  const marque = useMarque();
  const nom = marque.parDefaut ? t('common.appName') : marque.nomAffiche;

  if (variant === 'auth') {
    return (
      <div className="mt-8 text-center text-sm text-neutral-500">
        <p className="mb-4">
          &copy; {new Date().getFullYear()} {nom}. {t('common.rights')}
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to={ROUTES.LEGAL.TERMS}
            className="inline-flex min-h-11 items-center transition-colors hover:text-neutral-700"
          >
            {t('legal.terms.title')}
          </Link>
          <Link
            to={ROUTES.LEGAL.PRIVACY}
            className="inline-flex min-h-11 items-center transition-colors hover:text-neutral-700"
          >
            {t('legal.privacy.title')}
          </Link>
          <Link
            to={ROUTES.LEGAL.NOTICES}
            className="inline-flex min-h-11 items-center transition-colors hover:text-neutral-700"
          >
            {t('legal.notices.title')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <footer className="mt-auto border-t border-neutral-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="text-sm text-neutral-500">
            &copy; {new Date().getFullYear()} {nom}. {t('common.rights')}
          </div>
          <div className="flex gap-6 text-sm">
            <Link
              to={ROUTES.LEGAL.TERMS}
              className="inline-block py-1 text-neutral-500 transition-colors hover:text-neutral-700"
            >
              {t('legal.terms.title')}
            </Link>
            <Link
              to={ROUTES.LEGAL.PRIVACY}
              className="inline-block py-1 text-neutral-500 transition-colors hover:text-neutral-700"
            >
              {t('legal.privacy.title')}
            </Link>
            <Link
              to={ROUTES.LEGAL.NOTICES}
              className="inline-block py-1 text-neutral-500 transition-colors hover:text-neutral-700"
            >
              {t('legal.notices.title')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
